type TerminalIconProps = {
  className?: string;
  size?: number;
};

/** A deliberately plain terminal glyph: one window, one prompt, no cloud badge. */
export function TerminalIcon({ className, size = 24 }: TerminalIconProps) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      focusable="false"
      height={size}
      viewBox="0 0 24 24"
      width={size}
    >
      <rect
        x="3.25"
        y="4.25"
        width="17.5"
        height="15.5"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      {/* Title bar. Without it the frame is an anonymous rounded square at
          20px; this one rule is what makes the glyph read as a window. */}
      <path d="M3.25 8.25h17.5" stroke="currentColor" strokeWidth="1.5" />
      {/* Prompt chevron and cursor, centred in the content area below the bar
          (8.25 → 19.75) rather than in the whole frame, so the pair sits
          optically level instead of low. */}
      <path
        d="m7.5 11.75 2.25 2.25-2.25 2.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M12.25 16.25h4.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
